
import { styled } from '@material-ui/core/styles';

export const Wrapper = styled('div')({
  fontSize: '1.6rem',
  textAlign: 'center',
  margin: '100px 0 30px',
});
